import { createFileRoute } from '@tanstack/react-router';

import { ViewAsPage } from '@/features/view-as/view-as-page';

/**
 * Staff "view as" (read-only): the back office's one-time link lands here
 * (`#code=…`, never a query string). ONLINE-ONLY — it needs the server by nature.
 */
export const Route = createFileRoute('/view-as')({
  component: ViewAsPage,
});
